
    /* global server*/
    import { defineComponent } from 'vue';
    import { useUserStore } from './../../stores/user';
    import { useCompletedPaymentStore } from './../../stores/completed-payment';
    import receiptReport from '../Reports/ReceiptReport/receipt-report.vue';
    import { AxiosResponse } from 'axios';


    export default defineComponent({
        components: {
            receiptReport
        },
        data() {
            const userStore = useUserStore();

            return {
                paymentCompleteStore: useCompletedPaymentStore(),
                currentUser: userStore.user,
                confirmationNumber: '',
                hasAttachments: false,
                attachmentMessage: '',
            }
        },

        methods: {
            getPaymentInformation() {
                this.$axios.get('Payment/GetPaymentConfirmation', {
                    params: {
                        ID: this.paymentCompleteStore.PaymentID
                    }
                }).then((response: AxiosResponse<server.PaymentConfirmation>) => {
                    if (response.status == 200) {
                        this.confirmationNumber = response.data.ConfirmationNumber;
                        this.hasAttachments = response.data.HasAttachments;
                        this.attachmentMessage = response.data.AtachmentMessage;
                    }
                })
            },
            isMobile() {
                if (screen.width <= 768) {
                    return true;
                }
                else {
                    return false;
                }
            }

        },
        created() {
            this.getPaymentInformation();
        },
    });

